import * as yup from 'yup';
import { isValid } from 'date-fns';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

export const useOwnersWithoutEventsReportValidation = () => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape(
    {
      dataOd: yup
        .mixed()
        .nullable()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .test(
          'is-valid-date',
          formatMessage({ id: AppMessages['common.validation.date.format'] }),
          (value) => !value || isValid(value),
        )
        .test(
          'not-future',
          formatMessage({ id: AppMessages['common.validation.date.future'] }),
          (value) => !value || !isValid(value) || (value as Date) <= new Date(),
        )
        .when('dataDo', (validTo) => {
          if (validTo && isValid(validTo)) {
            return yup
              .mixed()
              .nullable()
              .transform((curr, orig) => (orig === '' ? null : curr))
              .test(
                'is-valid-date',
                formatMessage({ id: AppMessages['common.validation.date.format'] }),
                (value) => !value || isValid(value),
              )
              .test(
                'not-future',
                formatMessage({ id: AppMessages['common.validation.date.future'] }),
                (value) => !value || !isValid(value) || (value as Date) <= new Date(),
              )
              .test(
                'max-date',
                formatMessage({ id: AppMessages['common.validation.date.invalidRange'] }),
                (value) => !value || !isValid(value) || (value as Date) <= validTo,
              );
          }
          return yup
            .mixed()
            .nullable()
            .transform((curr, orig) => (orig === '' ? null : curr))
            .test(
              'is-valid-date',
              formatMessage({ id: AppMessages['common.validation.date.format'] }),
              (value) => !value || isValid(value),
            )
            .test(
              'not-future',
              formatMessage({ id: AppMessages['common.validation.date.future'] }),
              (value) => !value || !isValid(value) || (value as Date) <= new Date(),
            );
        })
        .optional(),
      dataDo: yup
        .mixed()
        .nullable()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .test(
          'is-valid-date',
          formatMessage({ id: AppMessages['common.validation.date.format'] }),
          (value) => !value || isValid(value),
        )
        .test('min-date', formatMessage({ id: AppMessages['common.validation.date.invalidRange'] }), function (value) {
          const dataOd = this.parent.dataOd;
          if (!value || !isValid(value)) return true;
          if (!dataOd || !isValid(dataOd)) return true;
          return (value as Date) >= dataOd;
        })
        .test(
          'max-date',
          formatMessage({ id: AppMessages['common.validation.date.future'] }),
          (value) => !value || !isValid(value) || (value as Date) <= new Date(),
        )
        .optional(),
    },
    [['dataOd', 'dataDo']],
  );

  return { schema };
};
